import type { PttSidecarConfig } from "../../pttSidecarClient";

export type PttState = "idle" | "recording" | "processing";

export type PttTurn = {
  id: string;
  query: string;
  /** null while the voice command is still running */
  readback: string | null;
  at: number;
};

export type PttKeyMode = "hold" | "toggle";

export type PttCaptureHandle = {
  startRecording: () => void | Promise<void>;
  stopRecording: () => void;
  isRecording: () => boolean;
};

export type PttTransport = PttCaptureHandle & {
  keyMode: PttKeyMode;
};

export type PttTransportKind = "aws" | "blob" | "browser";

/** Chromium-only. Firefox has no Web Speech API. */
export function chromiumSpeechRecognitionAvailable(): boolean {
  if (typeof window === "undefined") return false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  return Boolean(w.SpeechRecognition ?? w.webkitSpeechRecognition);
}

export function resolvePttTransportKind(
  config: PttSidecarConfig | null,
  sidecarOnline = true,
): PttTransportKind {
  if (!config) return chromiumSpeechRecognitionAvailable() ? "browser" : "blob";
  if (config.provider === "aws") return "aws";
  if (!sidecarOnline) {
    return chromiumSpeechRecognitionAvailable() ? "browser" : "blob";
  }
  return "blob";
}

/** Keep the active transport stable while a PTT turn is in flight. */
export function lockPttTransportKind(
  resolved: PttTransportKind,
  locked: PttTransportKind,
  sessionActive: boolean,
): PttTransportKind {
  if (!sessionActive) return resolved;
  return locked;
}
